const HEBREW = /[֐-׿]/;

/**
 * A user value inside Hebrew text, isolated with an explicit direction. `<bdi>` alone falls back to
 * the surrounding RTL direction for values without letters, which shows "-2" as "2-"; numbers and
 * codes are therefore isolated left-to-right, Hebrew text right-to-left.
 */
export function Value({ text }: { readonly text: string }) {
  return <bdi dir={HEBREW.test(text) ? 'rtl' : 'ltr'}>{text}</bdi>;
}
